import { Sidebar as SidebarComponent } from '@chocolate-soup-inc/cs-frontend-components';
import reactDomJSON from 'react-dom/package.json';
import { generatePath } from 'react-router-dom';
import routerJSON from 'react-router-dom/package.json';
import reactJSON from 'react/package.json';
import tsJSON from 'typescript/package.json';
import { usePrivateCompanyContext } from '../../routes/outlets/PrivateCompanyOutlet';
import { ADMINISTRATION_PATH, CUSTOM_BRICKS_PATH, DELIVERIES_PATH, EMPLOYEES_PATH, HISTORY_PATH, NEW_PATH, OVERVIEW_PATH } from '../../routes/paths';

const isProd = import.meta.env.REACT_APP_STAGE?.toLowerCase() == 'production';

export const Sidebar = () => {
  const { name, subdomain } = usePrivateCompanyContext();
  document.title = `${name} | Client Portal | Chocolate Soup`;
  //console.log('import.meta.env?:', import.meta.env);

  return (
    <SidebarComponent
      sections={[
        {
          title: import.meta.env.REACT_APP_STAGE != 'production' ? `React ${reactJSON.version}; DOM ${reactDomJSON.version}; Router ${routerJSON.version}; TS ${tsJSON.version};` : undefined,
          items: [
            {
              icon: 'group',
              label: 'Employees',
              path: EMPLOYEES_PATH
            },
            {
              icon: 'add_circle',
              label: 'Add new',
              path: generatePath(`${EMPLOYEES_PATH}/${NEW_PATH}`),
              indent: 1
            },
            {
              icon: 'local_shipping',
              label: 'Delivery',
              path: DELIVERIES_PATH
            },
            {
              icon: 'insights',
              label: 'Overview',
              path: generatePath(`${DELIVERIES_PATH}/${OVERVIEW_PATH}`),
              indent: 1
            },
            {
              icon: 'list_alt',
              label: 'Shipment History',
              indent: 1,
              path: generatePath(`${DELIVERIES_PATH}/${HISTORY_PATH}`)
            },
            {
              icon: 'settings',
              label: 'Administration',
              path: ADMINISTRATION_PATH
            }
          ]
        },
        ...(!isProd
          ? [
              {
                title: 'Custom Orders',
                items: [
                  {
                    icon: 'brick',
                    label: 'Custom Bricks',
                    path: CUSTOM_BRICKS_PATH
                  },
                  {
                    icon: 'add_circle',
                    label: 'New Order',
                    path: `${CUSTOM_BRICKS_PATH}/${NEW_PATH}`,
                    indent: 1 as const
                  }
                  /*{
              icon: 'face_retouching_natural',
              label: 'Life Events',
              path: LIFE_EVENTS_PATH
            },
            {
              icon: 'add_circle',
              label: 'New Order',
              path: `${LIFE_EVENTS_PATH}/${NEW_PATH}`,
              indent: 1
            },
            {
              icon: 'favorite',
              label: 'Care Packages',
              path: CARE_PACKAGES_PATH
            },
            {
              icon: 'add_circle',
              label: 'New Order',
              path: `${CARE_PACKAGES_PATH}/${NEW_PATH}`,
              indent: 1
            }*/
                ]
              }
            ]
          : []),
        {
          title: 'Coming soon!',
          items: [
            ...(isProd ? [{ icon: 'brick', label: 'Custom Bricks', path: '.', disabled: true }] : []),
            {
              icon: 'face_retouching_natural',
              label: 'Life Events',
              path: '.',
              disabled: true
            },
            {
              icon: 'favorite',
              label: 'Care Packages',
              path: '.',
              disabled: true
            }
          ]
        }
      ]}
      title={`${name} (${subdomain}) ${!isProd ? `[${import.meta.env.REACT_APP_STAGE?.toUpperCase()}]` : ''}`}
    />
  );
};
